/*
* Created by Skeets 2017-11-01
* */
var origWindowHeight;
history.replaceState(null, "", "");
window.onpopstate = function(e) {

  var $openCard = $(".dictionaryWordCardOpen");
  if ($openCard.length) {
    $(".closeDictionaryWord", $openCard).trigger("click");
    if (history.state.dictionary !== "open") {
      history.pushState({dictionary: "open"}, "", "");
    }
    return true;
  }
  if (e.state !== null && e.state.dictionary === "card") {
    $(".dictionaryAccordion[data-id=" + e.state.id + "]").trigger("click");
    return true;
  }

  if (nav.mode !== "dictionary") {

    history.back();
    return true;
  }
  nav.floater();
};
nav               = {
  touch       : null,
  ele         : $("#backNav"),
  holding     : 0,
  mode        : "bar",
  threshold   : 25,
  setx        : $(window).width,
  sety        : 0,
  xspeed      : 0,
  yspeed      : 0,
  x           : 0,
  xold        : 0,
  y           : 0,
  size        : 80,
  rightDip    : 70,
  rightDeepDip: 30,
  leftDip     : -10,
  leftDeepDip : -50,
  bottomMargin: 100,
  half        : 40,
  yold        : 0,
  movedEnough : true,
  moving      : false,
  mousedown   : false,

  move      : function() {
    nav.touch = null;
    if (this.xspeed === 0) {
      nav.xspeed = nav.x - nav.xold;
      nav.yspeed = nav.y - nav.yold;
      if (this.xspeed === 0) {
        {
          this.xspeed = 3;
        }
      }
    }

    this.moving = true;
    this.x      = this.x + this.xspeed;
    this.y      = this.y + this.yspeed;

    if (this.xspeed === 0) {
      this.xspeed = 1;
    }

    this.xspeed = this.xspeed * 1.1;
    this.yspeed = this.yspeed * 1.1;

    var hitSide = false;

    if (this.x < this.leftDeepDip) {
      this.x  = this.leftDeepDip;
      hitSide = true;
    }
    if (this.x > ($(window).width() - this.rightDeepDip)) {
      this.x  = ($(window).width() - this.rightDeepDip);
      hitSide = true;
    }

    if (this.y > $(window).height() - this.bottomMargin) {
      this.y = $(window).height() - this.bottomMargin;
    }
    if (this.y < 0) {
      this.y = 0;
    }

    this.updatePos();
    if (!hitSide) {
      var that = this;
      setTimeout(function() {
        that.move();
      }, 10);
      return true;
    }
    this.xspeed = 0;
    this.yspeed = 0;
    this.moving = false;
    this.setPos(true);
    this.undip();
  },
  undip     : function() {
    if (nav.touch !== null) {
      return;
    }
    var that = this;
    if (this.x < this.leftDip - 1) {
      this.x += (this.leftDip - this.x) / 10;
      this.updatePos();
      setTimeout(function() {
        that.undip();
      }, 10);
      return true;
    }
    if (this.x > ($(window).width() - this.rightDip) + 1) {
      this.x += (($(window).width() - this.rightDip) - this.x) / 10;
      this.updatePos();
      setTimeout(function() {
        that.undip();
      }, 10);
      return true;
    }

    this.moving = false;
  },
  setPos    : function(dip) {

    if (typeof dip === "undefined") {
      dip = false;
    }
    var x = parseInt(nav.ele.css("left"));
    var y = nav.ele.css("top");

    if (x < $(window).width() / 2) {
      x = this.leftDip;
    }
    else {
      x = $(window).width() - this.rightDip;
    }

    this.setx = parseInt(x);
    this.sety = parseInt(y);
    if (!dip) {
      this.x = x;
      this.y = y;
    }
    this.updatePos();
  },
  updatePos : function() {
    nav.ele.css({top: this.y, left: this.x});
  },
  doAction  : function() {
    this.setPos();

    if (this.holding > this.threshold) {
      $("#menuModal").modal("show");
    }
    else {
      this.dictionary();
    }
    return true;
  },
  countHold : function() {
    if (nav.touch !== null || nav.mousedown) {
      this.holding++;
      var that = this;
      setTimeout(function() {
        that.countHold();
      }, 10);
    }
  },
  dictionary: function() {
    origWindowHeight = $(window).height();
    this.transform();
    this.mode = "dictionary";
    this.ele.addClass("dictionaryMode");
    this.ele.removeClass("menuHead");
    $(".navFloater").hide();
    setTimeout(function() {
      $(".navDictionary").show();
      $("#dictionarySearch").focus();
      searchModeOn();
    }, 100);
  },
  floater   : function(setPos) {
    if (typeof setPos === "undefined") {
      setPos = false;
    }
    this.transform(setPos);

    this.goPos();
    this.mode = "float";
    $(".navDictionary").hide();
    // setTimeout(function() {
    $(".navFloater").show();
    // });
    this.ele.addClass("menuHead");
    this.ele.removeClass("dictionaryMode");
  },
  transform : function(setPos) {
    if (history.state === null) {
      history.pushState({dictionary: "open"}, "", "");
    }
    if (typeof setPos === "undefined") {
      setPos = false;
    }
    this.ele.addClass("navTrans");
    var that = this;
    setTimeout(function() {
      that.ele.removeClass("navTrans");
      if (setPos) {
        that.setPos();
      }

    }, 100);
  },
  goPos     : function() {
    this.x = this.setx;
    this.y = this.sety;
    this.updatePos();
  },
  inputXY   : function(x, y) {
    var tmpPos = {x: nav.xold, y: nav.yold};

    nav.xold = nav.x;
    nav.yold = nav.y;


    nav.x = x;
    nav.y = y;

    if (nav.xold === nav.x && nav.yold === nav.y) {
      nav.xold = tmpPos.x;
      nav.yold = tmpPos.y;
      return;
    }

    if (!nav.movedEnough) {
      nav.movedEnough = Math.abs(nav.setx - nav.x) > 50 || Math.abs(nav.sety - nav.y) > 50;
    }
    nav.updatePos();
  }
};

nav.ele.mousedown(function(e) {
  if (nav.mode !== "float") {
    return true;
  }
  nav.mousedown   = true;
  nav.movedEnough = false;
  nav.countHold();
  e.preventDefault();
});

$(document).on("mousemove", function(e) {
  if (nav.mousedown) {
    nav.inputXY(e.pageX - nav.half, e.pageY - nav.half);
  }
});

$(document).on("mouseup", function() {
  if (nav.mode !== "float") {
    return true;
  }
  if (nav.mousedown) {
    nav.mousedown = false;
    if (nav.moving === false) {
      if (nav.movedEnough) {
        nav.move();
      }
      else {
        nav.doAction();
      }

      nav.holding = 0;
    }
  }
});

$(document).mouseleave(function() {
  if (nav.mode !== "float") {
    return true;
  }
  if (nav.mousedown) {
    nav.mousedown = false;
    nav.move();
  }
});

document.getElementById("backNav").addEventListener('touchstart', function(e) {
  if (nav.moving === false && nav.mode === "float") {
    nav.touch       = getTouches(e, "changed");
    nav.movedEnough = false;
    nav.countHold();
    e.preventDefault();
  }
}, (passiveSupported) ? {passive: false} : false);


document.addEventListener('touchmove', function(e) {

  if (nav.touch !== null && nav.mode === "float") {
    var touches = getTouches(e);


    touches.forEach(function(thatTouch) {
      if (thatTouch.identifier === nav.touch[0]) {
        nav.inputXY(thatTouch.pageX - nav.half, thatTouch.pageY - nav.half);
        return true;
      }
    });


    e.preventDefault();

  }
}, (passiveSupported) ? {passive: false} : false);

document.addEventListener('touchend', function(e) {


  if (nav.touch !== null && nav.mode === "float") {
    if (nav.moving === false) {
      if (nav.movedEnough) {
        nav.move();
      }
      else {
        nav.doAction();
      }

      nav.holding = 0;
    }
  }

  if ($(e.target).hasClass("navMakeFloater") || $(e.target).parent().hasClass("navMakeFloater")) {
    $(e.target).trigger("click");
    e.preventDefault();
  }


  nav.touch = null;

}, (passiveSupported) ? {passive: false} : false);


nav.floater(true);

$(".navMakeFloater").click(function() {
  if (nav.mode !== "float") {
    nav.floater();
    return false;
  }
});

